export const SET_SOCKETS = 'SET_SOCKETS';
export const SET_SOCKET = 'SET_SOCKET';
export const ADD_SOCKET = 'ADD_SOCKET';
export const UPDATE_SOCKET = 'UPDATE_SOCKET';
export const REMOVE_SOCKET = 'REMOVE_SOCKET';
export const CLEAR_SOCKET = 'CLEAR_SOCKET';
export const CLEAR_SOCKETS = 'CLEAR_SOCKETS';
